<footer>
  <div class="content-container">
    <button id="ot-sdk-btn" class="ot-sdk-show-settings">Cookie Settings</button>
  </div>
</footer>
